import React from "react";

import Box from "veneer/Box";
import {
  ChevronLeftIconButton,
  ChevronRightIconButton,
} from "veneer/IconButton";
import Stack from "veneer/Stack";

interface ContentGroupNavigatorProps {
  index?: number;
  onNavigate?: (direction: number) => void;
  totalElements?: number;
}

export function ContentGroupNavigator({
  index = 0,
  onNavigate = () => {},
  totalElements = 0,
}: ContentGroupNavigatorProps) {
  return (
    <Box dataTestId="content-group-navigator" mx={1}>
      <Stack direction="row" justifyContent="space-between">
        <ChevronLeftIconButton
          dataTestId="content-group-previous"
          disabled={index === 0}
          onClick={() => onNavigate(-1)}
          title="Previous item"
        />
        <ChevronRightIconButton
          dataTestId="content-group-next"
          disabled={totalElements <= 1 || index >= totalElements - 1}
          onClick={() => onNavigate(1)}
          title="Next item"
        />
      </Stack>
    </Box>
  );
}
